import { FormikProps } from "formik";
import { Form } from "react-bootstrap";
import { Values, ValuesKey } from "./types";

type Props = {
  formik: FormikProps<Values>;
};

const showError = (formik: FormikProps<Values>, field: ValuesKey) =>
  Boolean(formik.touched[field] && formik.errors[field]);

const FalseReportForm = ({ formik }: Props) => (
  <Form className="flex flex-column flex-gap-4">
    <Form.Text className="m-0" style={{ lineHeight: "1.5" }}>
      Submit a suspected false positive or false negative for review by our
      threat research team.
      <br />
      Your report will be evaluated, and you&apos;ll be notified if the
      classification is updated.
    </Form.Text>
    <section>
      <Form.Label>Report Type:</Form.Label>
      <Form.Check inline name="type">
        <Form.Check.Input
          id="false-positive-check"
          className="cursor-pointer"
          checked={formik.values.type === "false-positive"}
          type="radio"
          onChange={() => formik.setFieldValue("type", "false-positive")}
        />
        <Form.Check.Label
          htmlFor="false-positive-check"
          className="cursor-pointer"
        >
          False Positive
        </Form.Check.Label>
      </Form.Check>
      <Form.Check inline name="type">
        <Form.Check.Input
          id="false-negative-check"
          className="cursor-pointer"
          checked={formik.values.type === "false-negative"}
          type="radio"
          onChange={() => formik.setFieldValue("type", "false-negative")}
        />
        <Form.Check.Label
          htmlFor="false-negative-check"
          className="cursor-pointer"
        >
          False Negative
        </Form.Check.Label>
      </Form.Check>
    </section>
    <section>
      <Form.Label htmlFor="comment">Comment:</Form.Label>
      <Form.Control
        id="comment"
        name="comment"
        as="textarea"
        value={formik.values.comment}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        isInvalid={showError(formik, "comment")}
        type="text"
        placeholder="Enter Comment"
        required
      />
      <Form.Text>
        Provide any context or evidence that may help with the review.
      </Form.Text>
      <Form.Control.Feedback type="invalid">
        {formik.errors.comment}
      </Form.Control.Feedback>
    </section>
    <section>
      <Form.Text className="m-0">
        Email updates will be sent to the address associated with your account:{" "}
        <b className="text-gray">{formik.values.contact}</b>
      </Form.Text>
    </section>
  </Form>
);

export default FalseReportForm;
